<div class="demonstration_content"
    [class.validated]="this.matchValidated" 
    >
    <div class="demonstration_infos">
        <div class="demonstration_title">{{'DEMONSTRATION.TITLE' | translate}} <span class="tester_name">{{this.testerName}}</span></div>
        <div class="demonstration_date">{{'DEMONSTRATION.CREATION_DATE' | translate}} {{this.dateCreation | demoozDateToString}}</div>
    </div>
    <div class="demonstration_actions">
        @if(this.match.tester.phone){
            <demooz-button type="button" icon="call" [withShadow]="true" [invertColor]="this.matchValidated" color="primary" (click)="this.callTester()"/> 
            <demooz-button type="button" icon="chatbubble" [withShadow]="true" [invertColor]="this.matchValidated" color="primary" (click)="this.sendSmsTester()"/> 
        }
        @if(!this.match.salesDeniedDefinitely 
            && (!this.match.validation?.owner?.hasValidated 
                || (this.demonstrationsContent?.isSalesPathButtonVisible && this.matchValidated && this.match.nbSales < this.salesContent?.nbMaxSales) ) ){
            
            @if(this.matchValidated){
                @if(this.isShareSupported){
                    <demooz-button type="button" label="{{'DEMONSTRATION.BUTTON_SEND_SALE_PROOF' | translate}}" [withShadow]="true" [invertColor]="this.matchValidated" color="primary" (click)="this.shareLinkSaleProof()"/> 
                }
            }
            @else if(!this.match.validation?.owner?.hasValidated){
                <demooz-button type="button" label="{{'DEMONSTRATION.BUTTON_VALIDATE_MATCH' | translate}}" [withShadow]="true" [invertColor]="this.matchValidated" color="primary" [isFetching]="this.isFetchingValidate" (click)="this.validateMatch()"/> 
            }
        }
    </div>
</div>